import { Card, FormControl, InputLabel, Select, MenuItem, Box, Typography } from "@mui/material";
import { FC } from "react";
import { ICollection } from "../../../../../../../interfaces/ICollection";
import styled from "@emotion/styled";
import emptyImage from '../../../../../../../assets/img/emptyImage.png'
import { baseURL } from "../../../../../../../config";

const BASE_URL = baseURL;


const CollectionImage = styled.img`
    width: 200px;
    height: 100px;
    object-fit: contain;
`


interface CollectionComponentProps {
    disabled: boolean;
    collectionId: string;
    onSetCollectionId: (collectionId: string) => void;
    collectionsData: ICollection[] | null;
}

const CollectionComponent: FC<CollectionComponentProps> = ({
    disabled,
    collectionId,
    onSetCollectionId,
    collectionsData,
}) => {
    return (
        <Card sx={{ p: 4 }}>
            <FormControl fullWidth>
                <InputLabel>Kolekcja</InputLabel>
                <Select
                    disabled={disabled}
                    value={collectionId}
                    label="Kolekcja"
                    onChange={e => onSetCollectionId(e.target.value)}
                >
                    <MenuItem
                        key={'default'}
                        value={''}
                    >
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <CollectionImage
                                src={emptyImage}
                                alt={'empty'}
                            />
                            <Typography variant="h6">Brak kolekcji</Typography>
                        </Box>
                    </MenuItem>
                    {collectionsData && collectionsData.map((collectionItem) => (
                        <MenuItem
                            key={collectionItem._id}
                            value={collectionItem._id}
                        >
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <CollectionImage
                                    src={`${BASE_URL}${collectionItem.image}`}
                                    alt={collectionItem.name}
                                />
                                <Typography variant="h6">{collectionItem.name}</Typography>
                            </Box>
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Card>
    )
}

export default CollectionComponent;